import { render, staticRenderFns } from "./adAdmin.vue?vue&type=template&id=86e98ec6&"
import script from "./adAdmin.vue?vue&type=script&lang=js&"
export * from "./adAdmin.vue?vue&type=script&lang=js&"
import style0 from "./adAdmin.vue?vue&type=style&index=0&id=86e98ec6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports